import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import qrcode from "../../../images/qr.png";
import classNames from "classnames";
import styles from "./pharmaRetailerInvoice.module.scss";
import { Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPharmaSalesRetailerByIdSlice } from "../../../store/slices/pharmaSalesRetailerSlice";
import { useNavigate } from "react-router-dom";

const ViewPharmaRetailerInvoice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPharmaRetailerInvoice, setShowPharmaRetailerInvoice] =
    useState(false);
  const pharmaRetailerInvoiceRef = useRef();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinic = clinicInfo && clinicInfo?.length > 0 ? clinicInfo[0] : [];
  const { pharmaSalesRetailerInfo } = useSelector(
    (state) => state.pharmaSalesRetailer
  );
  const retailerSalesId = sessionStorage.getItem("retailerSalesId");
  const { token } = useSelector((state) => state.auth);
  useEffect(() => {
    if (retailerSalesId) {
      dispatch(getPharmaSalesRetailerByIdSlice({ id: retailerSalesId, token }));
    }
  }, [dispatch, retailerSalesId, token]);

  const downloadInvoice = async () => {
    setShowPharmaRetailerInvoice(true);

    setTimeout(async () => {
      const pages = document.querySelectorAll(`.${styles.page}`);
      const pdf = new jsPDF("p", "mm", "a4");

      for (let i = 0; i < pages.length; i++) {
        const canvas = await html2canvas(pages[i], {
          scale: 2, // ✅ KEY FIX
          useCORS: true,
          backgroundColor: "#fff",
        });

        const imgData = canvas.toDataURL("image/png");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        pdf.addImage(
          imgData,
          "PNG",
          0,
          0,
          pageWidth,
          pageHeight,
          undefined,
          "FAST"
        );

        if (i < pages.length - 1) pdf.addPage();
      }

      pdf.save(
        `Pharma_invoice_${pharmaSalesRetailerInfo?.retailerId?.name}.pdf`
      );

      setShowPharmaRetailerInvoice(false);
    }, 300);
  };

  const printInvoice = async () => {
    setShowPharmaRetailerInvoice(true);

    setTimeout(async () => {
      const pages = document.querySelectorAll(`.${styles.page}`);
      const pdf = new jsPDF("p", "mm", "a4");

      for (let i = 0; i < pages.length; i++) {
        const canvas = await html2canvas(pages[i], {
          scale: 2, // 🔥 KEY FIX
          useCORS: true,
          backgroundColor: "#fff",
        });

        const imgData = canvas.toDataURL("image/png");

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(
          imgData,
          "PNG",
          0,
          0,
          pdfWidth,
          pdfHeight,
          undefined,
          "FAST" // 🔥 avoids compression blur
        );

        if (i < pages.length - 1) pdf.addPage();
      }

      pdf.autoPrint();
      window.open(pdf.output("bloburl"), "_blank");

      setShowPharmaRetailerInvoice(false);
    }, 300);
  };

  const ROWS_PER_PAGE = 10; // adjust based on your row height
  const paginatedItems = [];
  const items = pharmaSalesRetailerInfo?.item || [];

  for (let i = 0; i < items.length; i += ROWS_PER_PAGE) {
    paginatedItems.push(items.slice(i, i + ROWS_PER_PAGE));
  }

  const calculatePageTotals = (items = []) => {
    return items.reduce(
      (acc, row) => {
        acc.qty += Number(row?.quantity || 0);
        acc.discount += Number(row?.discount || 0);
        acc.taxable += Number(row?.taxable || 0);
        acc.cgst += Number(row?.cgst || 0);
        acc.sgst += Number(row?.sgst || 0);
        acc.total += Number(row?.total || 0);
        return acc;
      },
      {
        qty: 0,
        discount: 0,
        taxable: 0,
        cgst: 0,
        sgst: 0,
        total: 0,
      }
    );
  };

  const amountToWords = (amount) => {
    if (amount === null || amount === undefined) return "";

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const numToWords = (num) => {
      if (num < 20) return ones[num];
      if (num < 100)
        return `${tens[Math.floor(num / 10)]} ${ones[num % 10]}`.trim();
      if (num < 1000)
        return `${ones[Math.floor(num / 100)]} Hundred ${numToWords(
          num % 100
        )}`.trim();
      if (num < 100000)
        return `${numToWords(Math.floor(num / 1000))} Thousand ${numToWords(
          num % 1000
        )}`.trim();
      if (num < 10000000)
        return `${numToWords(Math.floor(num / 100000))} Lakh ${numToWords(
          num % 100000
        )}`.trim();
      return `${numToWords(Math.floor(num / 10000000))} Crore ${numToWords(
        num % 10000000
      )}`.trim();
    };

    const rupees = Math.floor(amount);
    const paise = Math.round((amount - rupees) * 100);

    let words = `Rupees ${numToWords(rupees)}`;

    if (paise > 0) {
      words += ` and ${numToWords(paise)} Paise`;
    }

    return `${words} Only`;
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="m-0">Pharma Invoice</h4>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/pharmaSalesRetailer")}
        >
          Back to List
        </button>
      </div>
      <Row
        className={
          showPharmaRetailerInvoice
            ? styles.InvoiceWrapper
            : styles.InvoiceWrapperTwo
        }
      >
        <div className="col-lg-12">
          <div
            className={classNames(
              styles.InvoiceCard,
              "card",
              showPharmaRetailerInvoice && styles.pdfMode
            )}
            ref={pharmaRetailerInvoiceRef}
            style={{
              backgroundImage: `url(${clinic?.hospitalInfo?.waterMark})`,
            }}
          >
            <div className={styles.rudraInvoice}>
              {/* ===== OUTER BORDER ===== */}
              {paginatedItems.map((pageItems, pageIndex) => {
                const pageTotals = calculatePageTotals(pageItems);
                return (
                  <div className={styles.page} key={pageIndex}>
                    {/* ================= HEADER ================= */}
                    <div className={styles.headerRow}>
                      {/* ===== LEFT: SELLER ===== */}
                      <div className={styles.sellerBox}>
                        <h4>{clinic?.clinicName}</h4>
                        <div>
                          {clinic?.clinicAddress?.plot},{" "}
                          {clinic?.clinicAddress?.area},{" "}
                          {clinic?.clinicAddress?.city?.name},{" "}
                          {clinic?.clinicAddress?.state?.name}
                        </div>
                        <div>Phone:{" "} {clinic?.phone}</div>
                        <div>
                          Email: {clinic?.accountInfo?.accountEmail}
                        </div>
                        <div>
                          D.L. No: {clinic?.accountInfo?.dlNumber}
                        </div>
                        <div className={styles.invoiceMeta}>
                          <div>GSTIN: {clinic?.accountInfo?.gst}</div>
                          <div>
                            DrugsBazaar ID: {clinic?.accountInfo?.drugsBazaarId}
                          </div>
                        </div>
                        <div className={styles.invoiceMeta}>
                          <div>PAN: {clinic?.accountInfo?.pan}</div>
                          <div>FSSAI: {clinic?.accountInfo?.fssaiLicenseNumber}</div>
                        </div>
                      </div>
                      <div className={styles.verticalDivider}></div>
                      {/* ===== RIGHT: TAX INVOICE + TO ===== */}
                      <div className={styles.invoiceBox}>
                        <div className={styles.invoiceTitleRow}>
                          <span className={styles.taxInvoice}>TAX INVOICE</span>
                          <span className={styles.credit}>CREDIT</span>
                        </div>

                        <div className={styles.toBox}>
                          <b>To</b> {"  "}
                          <b>{pharmaSalesRetailerInfo?.retailerId?.name}</b>
                          <br />
                          <div className={styles.invoiceMeta}>
                            {pharmaSalesRetailerInfo?.retailerId?.address.replace(
                              /<[^>]*>/g,
                              ""
                            )}
                            <div>
                              <b>State:</b> Odisha (21)
                            </div>
                          </div>
                          <span>
                            GSTIN/UIN:{" "}
                            {pharmaSalesRetailerInfo?.retailerId?.gstin}
                          </span>
                          <span>
                            D.L. No. :{" "}
                            {pharmaSalesRetailerInfo?.retailerId?.dlno}
                          </span>
                        </div>

                        <div className={styles.invoiceMeta}>
                          <div>
                            <b>Invoice No:</b> {pharmaSalesRetailerInfo?.billId}
                          </div>
                          <div>
                            <b>Date:</b>{" "}
                            {pharmaSalesRetailerInfo?.billDate &&
                              new Date(
                                pharmaSalesRetailerInfo?.billDate
                              ).toLocaleDateString("en-IN")}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ===== TABLE ===== */}
                    <div className={styles.body}>
                      <table className={styles.table}>
                        <thead>
                          <tr>
                            <th width="4%">Sl. No.</th>
                            <th width="4%">MF</th>
                            <th width="6%">HSN</th>
                            <th width="15%">Product</th>
                            <th width="5%">Pack</th>
                            <th width="7%">Batch</th>
                            <th width="5%">Exp</th>
                            <th width="6%">MRP</th>
                            <th width="6%">R.MRP</th>
                            <th width="6%">Rate</th>
                            <th width="5%">Qty</th>
                            <th width="5%">Disc</th>
                            <th width="7%">Taxable</th>
                            <th width="6%">CGST</th>
                            <th width="6%">SGST</th>
                            <th width="7%">Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          {pageItems.map((row, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td></td>
                              <td>{row?.stockId?.hsnCode}</td>
                              <td>{row?.stockId?.name}</td>
                              <td>{row?.matchedPurchase?.item?.unit}</td>
                              <td>{row?.stockId?.batchNumber}</td>
                              <td>
                                {row?.expiryDate &&
                                  new Date(row?.expiryDate).toLocaleDateString(
                                    "en-IN",
                                    {
                                      month: "2-digit",
                                      year: "2-digit",
                                    }
                                  )}
                              </td>
                              <td>{row?.mrp?.toFixed(2)}</td>
                              <td>{row?.rmrp?.toFixed(2)}</td>
                              <td>{row?.rate?.toFixed(2)}</td>
                              <td>
                                {row?.quantity}
                                {row?.freeQuantity !== 0 &&
                                  `+${row?.freeQuantity}`}
                              </td>
                              <td>{row?.discount?.toFixed(2)}</td>
                              <td>{row?.taxable?.toFixed(2)}</td>
                              <td>{row?.cgst?.toFixed(2)}</td>
                              <td>{row?.sgst?.toFixed(2)}</td>
                              <td>{row?.total?.toFixed(2)}</td>
                            </tr>
                          ))}

                          {/* ===== TOTAL ROW ===== */}
                          <tr className={styles.totalRow}>
                            <td
                              colSpan={10}
                              style={{ textAlign: "right", fontWeight: "bold" }}
                            >
                              Total
                            </td>
                            <td>{pageTotals?.qty}</td>
                            <td>{pageTotals?.discount?.toFixed(2)}</td>
                            <td>{pageTotals?.taxable?.toFixed(2)}</td>
                            <td>{pageTotals?.cgst?.toFixed(2)}</td>
                            <td>{pageTotals?.sgst?.toFixed(2)}</td>
                            <td>{pageTotals?.total?.toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* ===== FOOTER ===== */}
                    <div className={styles.footer}>
                      {/* Left totals */}
                      <div className={styles.footerLeft}>
                        <div>
                          5% GST : {pageTotals?.taxable?.toFixed(2)} CGST :{" "}
                          {pageTotals?.cgst?.toFixed(2)} SGST :{" "}
                          {pageTotals?.sgst?.toFixed(2)}
                        </div>
                        <div>
                          {amountToWords(Math.round(pageTotals?.total))}
                        </div>
                        <div className={styles.invoiceMeta}>
                          <div>
                            Total Units: {pageItems?.length}/{pageTotals?.qty}{" "}
                          </div>
                        </div>
                        <div>
                          E. & O.E. * NB : This registration certificate is
                          valid on the date of this invoice * Net amount is
                          rounded off * We do here by give the warranty that the
                          above goods sold by us do not contravene in any way
                          the provisions of section 18 of the Drugs & Cosmetic
                          Act. 1940. Tranport:
                        </div>
                      </div>

                      {/* Right Net Amount */}
                      <div className={styles.footerRight}>
                        <div className={styles.netAmount}>
                          NET AMOUNT: {"   "}₹{" "}
                          {Math.round(pageTotals?.total).toFixed(2)}
                        </div>
                        <div className={styles.signature}>
                          <b>For {clinic?.clinicName}</b>
                          <br />
                          <br />
                          {/* <img src={clinic?.hospitalInfo?.authorizedSignature} />
                        <div>Authorised Signatory</div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <button
            className="btn btn-primary mt-3 text-white"
            onClick={downloadInvoice}
          >
            Download PDF
          </button>
          <button
            className="btn btn-success mt-3 text-white"
            onClick={printInvoice}
          >
            Print Invoice
          </button>
        </div>
      </Row>
    </>
  );
};

export default ViewPharmaRetailerInvoice;
